import Link from 'next/link';
import styled from 'styled-components';

import { TCardMode } from '@/modules/game/types';

import { typography } from '@/styles/helpers';

export const ScGameCardTitle = styled(Link)`
  display: block;
  ${typography['caption1bold']};
  line-height: 18px;
  letter-spacing: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const ScGameCardProvider = styled(Link)`
  ${typography['caption2regular']};
  line-height: 14px;
  letter-spacing: 0;
  overflow: hidden;
  text-overflow: ellipsis;
`;

interface IScGameCardContainerProps {
  url: string;
  mode: TCardMode;
}

export const ScGameCardContainer = styled.div<IScGameCardContainerProps>`
  min-width: 0;
  max-width: 100%;

  & .bottom {
    margin-top: 4px;
  }

  ${ScGameCardTitle} {
    color: ${({ theme, mode }) =>
      mode === 'dark' ? theme.whiteColor : theme.blackColor};
  }

  ${ScGameCardProvider} {
    color: ${({ theme, mode }) =>
      mode === 'dark' ? 'rgba(255, 255, 255, 0.6)' : theme.blackLightColor};
    transition: color 0.2s ease-in-out;

    @media (hover: hover) {
      &:hover {
        color: ${({ theme, mode }) =>
          mode === 'dark' ? theme.whiteColor : theme.blackColor};
      }
    }
  }
`;
